













































import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder | undefined>
  },
  data() {
    return {
      active: false,
      req: {
        publishesAt: null as Date | null,
        note: ""
      }
    };
  },
  watch: {
    active(newValue: boolean) {
      if (newValue && this.publishmentOrder) {
        this.req.publishesAt = new Date(this.publishmentOrder.publishesAt);
      }
    }
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.publishmentOrder) {
        return;
      }
      await this.$store.dispatch("patch", [
        this.publishmentOrder["@id"] + "/publishes_at",
        this.req
      ]);
      this.$emit("success");
      cb();
    }
  }
});
